import { getChainDisplayName } from '@passkeys/assets';
import ChainIcon from '@passkeys/ui/chain-icon';
import Text from '@passkeys/ui/text';

import type { Asset } from '@/types';
import PickerModal from '@/ui/components/picker-modal';
import actions from '@/ui/flux/actions';
import type { ChainSelection } from '@/ui/pages/manage-tokens/types';

function renderChain(asset: Asset) {
  return (
    <div className="flex items-center gap-x-2">
      <ChainIcon
        name={asset.name}
        displayName={asset.displayName}
        size={32}
        colored
      />
      <Text dataTestId="chain-name">{getChainDisplayName(asset)}</Text>
    </div>
  );
}

function showFilterChainsModal({
  options,
  defaultSelected,
}: {
  options: Asset[];
  defaultSelected: Asset[];
}): Promise<{ result: ChainSelection }> {
  return actions.modal.show({
    title: 'Filter chains',
    fullscreen: true,
    reactContent: (
      <PickerModal
        options={options}
        getOptionKey={(chain) => chain.name}
        renderOption={renderChain}
        defaultSelected={defaultSelected}
        multiple
        includeAllOption
        onClose={() => {}} // FIXME: Improve `reactContent` type to avoid having to pass `onClose` here.
      />
    ),
  });
}

export default showFilterChainsModal;
